import {css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import * as React from 'react';

interface OwnProps {}

type Props = OwnProps;

export const EditableFieldWrapper: React.FC<Props> = (props) => {
  const {children, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div {...restProps} css={styles.editableFieldWrapper}>
      {children}
    </div>
  );
};

EditableFieldWrapper.displayName = 'EditableFieldWrapper';

const getStyles: GetStylesFunction = (options) => ({
  editableFieldWrapper: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${options?.theme?.spacing(1)}`,
    width: '100%',
    height: '100%',
  }),
});
